import {
  Alert,
  Details,
  LinkButton,
  PageHeader,
  readJson,
  Section,
  Skeleton,
} from "@emdur/ui";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ProposalReview } from "../components/ProposalReview";
import { useRegistry } from "../components/RegistryProvider";
import { useApi } from "../lib/apiContext";
import { appHref } from "../lib/clients";
import { errorText } from "../lib/errors";
import { type Proposal, proposalPath } from "../lib/proposals";
export function ProposalDetail() {
  const { org = "", proposalId = "" } = useParams();
  const api = useApi();
  const registry = useRegistry();
  const [proposal, setProposal] = useState<Proposal | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let current = true;
    setProposal(null);
    readJson<Proposal>(api.fetch, proposalPath(org, proposalId)).then(
      (answer) => {
        if (current) setProposal(answer.data);
      },
      (failure) => {
        if (current) setError(errorText(failure));
      },
    );
    return () => {
      current = false;
    };
  }, [api.fetch, org, proposalId]);
  if (!proposal)
    return error ? (
      <Alert tone="danger">{error}</Alert>
    ) : (
      <Skeleton label="Loading proposal" />
    );
  return (
    <div className="flex flex-col gap-5">
      <LinkButton variant="quiet" href="/approvals">
        ← Approvals
      </LinkButton>
      <PageHeader
        title="Review proposal"
        description="Your decision is recorded with the proposed change and its agent."
      />
      <ProposalReview
        proposal={proposal}
        autoVerify
        onDecided={(done) => {
          setProposal(done);
          void registry.reload();
        }}
      />
      {proposal.arguments.path?.client_id && (
        <LinkButton href={appHref(org, proposal.arguments.path.client_id)}>
          View app
        </LinkButton>
      )}
      {proposal.evidence?.length ? (
        <Section title="Evidence">
          <Details
            items={proposal.evidence.map((item) => [
              item.kind,
              item.excerpt ?? item.ref,
            ])}
          />
        </Section>
      ) : null}
      {proposal.result && proposal.state === "failed" && (
        <Alert tone="danger">
          The approved change could not run. Review the app and ask the agent
          for a new proposal.
        </Alert>
      )}
    </div>
  );
}
